import './assets/css/global.css';
import './services/socket';
import './version';
import 'core-js';
import './errorHandler';
import React from 'react';
import { store } from './redux/store';
import { render } from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { initSocket } from 'services/socket';

initSocket(store);

render(
  <Sentry.ErrorBoundary>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}
